import { fetchOembed } from './fetch-oembed';
import { insertTextEditorEntity } from './insert-text-editor-entity';
import { setTextEditorEntityData } from './set-text-editor-entity-data';
import { getTextEditorStateByKey } from '../selectors/text-editor-selectors';
import { buildUrl } from '../services/video-embed';

export const insertTextEditorVideoEmbed = ({ identifier, ...entityData }) => (dispatch, getState) => {
  const editorState = getTextEditorStateByKey(getState(), identifier);
  const entityKey = editorState
    .getCurrentContent()
    .createEntity('VIDEO-EMBED', 'IMMUTABLE', {
      ...entityData,
      isLoading: true,
    })
    .getLastCreatedEntityKey();

  dispatch(insertTextEditorEntity({ identifier, entityKey }));
  const publicUrl = buildUrl(entityData.url);
  return dispatch(fetchOembed(publicUrl)).then(oembed =>
    dispatch(
      setTextEditorEntityData({
        identifier,
        entityKey,
        entityData: {
          oembed,
          isLoading: false,
        },
      })
    )
  );
};



// WEBPACK FOOTER //
// ./app/actions/insert-text-editor-video-embed.js